import styles from './FJDiscountView.module.less';
import FJLocalStore from '../../../store/FJLocalStore.js';
import CloseIcon from '../../../assets/svg/mobile-close.svg?react';
import FJTimepiece from './FJTimepiece.jsx';
import FJItem from './FJItem.jsx';
import FJButton from '../../../common/components/FJButton/FJButton.jsx';
import { useMemo } from 'react';

const baseUrl = 'https://resource.flexclip.com/app/subscription/img/';

const PURCHASES = [
    {
        base: '300',
        baseUnit: 'Credits',
        present: '',
        presentUnit: '',
        price: 9.99,
        priceUnit: '$',
        packageName: 'ai_point_package_2',
    },
    {
        base: '800',
        baseUnit: 'Credits',
        present: '',
        presentUnit: '',
        price: 19.99,
        priceUnit: '$',
        packageName: 'ai_point_package_4',
    },
    {
        base: '1400',
        baseUnit: 'Credits',
        present: '',
        presentUnit: '',
        price: 29.99,
        priceUnit: '$',
        packageName: 'ai_point_package_6',
    },
];

const FJDiscountView = props => {
    const {
        data = {},
        selectedIndex,
        exchangeRate = 1,
        currentCountryMonetary = '$',
        currentCountryMonetaryISO = 'USD',
        onClose,
        onSelect,
        onUpgrade,
    } = props;

    const { expired_at = -1, percent_off, coupon = '' } = data || {};

    const discount = useMemo(() => {
        if (!percent_off) return 1;
        const a = Number(percent_off.replace('%', ''));
        return 1 - a / 100;
    }, [percent_off]);
    const time = useMemo(() => {
        if (!expired_at) return 0;
        const curTime = new Date().getTime();
        return expired_at * 1000 - curTime;
    }, [expired_at]);

    const _onUpgrade = () => {
        onUpgrade && onUpgrade(time > 0 ? coupon : '');
    };

    return (
        <div className={styles.box}>
            <CloseIcon className={styles.close} onClick={onClose} />
            <div className={styles.title1}>{FJLocalStore._('time-limited-title')}</div>
            <div className={styles.title2}>{FJLocalStore._('time-limited-desc')}</div>

            <FJTimepiece time={time} />
            <div className={styles.list}>
                {PURCHASES.map((data, index) => {
                    const { base, price } = data;
                    return (
                        <FJItem
                            onClick={() => onSelect && onSelect(index)}
                            key={index}
                            credit={base}
                            price={price}
                            discount={time > 0 ? discount : 1}
                            exchangeRate={exchangeRate}
                            currentCountryMonetary={currentCountryMonetary}
                            currentCountryMonetaryISO={currentCountryMonetaryISO}
                            isSelected={selectedIndex === index}
                        />
                    );
                })}
            </div>
            <FJButton
                icon={
                    <img
                        src={`${baseUrl}Credits-20.webp`}
                        alt='coin'
                        className={styles.button_icon}
                        width={20}
                        height={20}
                    />
                }
                textClassName={styles.button_text}
                className={styles.button}
                text={FJLocalStore._('upgrade-now')}
                type={'gradient'}
                onClick={_onUpgrade}
            />
        </div>
    );
};

export default FJDiscountView;
